var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/_stackClear.js
// module id = ./node_modules/recharts/node_modules/lodash/_stackClear.js
// module chunks = 1